import React from "react";
import { Box } from "grid-styled";
import Label from "./Label";
import Input from "./Input";
import ErrorMessage from "./ErrorMessage";

class InputContainer extends React.Component {
  render() {
    let labelProps = {};
    let inputProps = {};

    const {
      input,
      meta: { touched, error } = {},
      size,
      showLabel = true,
      innerRef,
      labelText,
      name,
      fieldComponent,
      ...otherProps
    } = this.props;

    if (input) {
      labelProps = { htmlFor: input.name };
      inputProps = { ...input, id: input.name };
    } else if (name) {
      labelProps = { htmlFor: name };
      inputProps = { id: name, name };
    }

    const hasError = touched && error;
    const FieldComponent = fieldComponent || Input;

    return (
      <Box>
        {showLabel && (
          <Label
            {...labelProps}
            size={size}
            hasError={hasError}
            children={labelText}
          />
        )}
        {this.props.children || (
          <FieldComponent
            {...otherProps}
            {...inputProps}
            hasError={hasError}
            ref={innerRef}
            size={size}
          />
        )}
        {hasError && <ErrorMessage>{error}</ErrorMessage>}
      </Box>
    );
  }
}

export default InputContainer;



// WEBPACK FOOTER //
// ./src/components/forms/InputContainer.js